<script setup>
import CompBreadCrumbs from "@/components/CompBreadCrumbs"
import IconsComp from "@/components/IconsComp"
import { ref, onMounted, inject, getCurrentInstance } from 'vue'
import { useProgramStore, useEdictStore, useAuthStore } from "@/stores"
import { useRouter, useRoute } from 'vue-router'
import moment from "moment-timezone";

moment.tz.setDefault("America/Sao_Paulo").locale("pt-br");

const router = useRouter()
const authStore = ref(useAuthStore())
const subscriptionClosed = ref(false)
const classifiedProjects = ref([])
const clickCount = ref(0)
const program = ref({ loading: true });
const edict = ref(null);

onMounted(async () => {
    const slidesContainer = document.querySelector(".slides-container");
    const slideWidth = slidesContainer.querySelector(".slide").clientWidth;
    const prevButton = document.querySelector(".prev");
    const nextButton = document.querySelector(".next");

    nextButton.addEventListener("click", () => {
        slidesContainer.scrollLeft += slideWidth + 17;
    });

    prevButton.addEventListener("click", () => {
        slidesContainer.scrollLeft -= slideWidth + 17;
    });

    program.value = { loading: true };
    await useProgramStore().find(3).then(response => program.value = response.data);
    edict.value = program.value.ultimoEdital

    if (!edict.value) {
        router.back()
        return;
    }

    if (!authStore.value.user) {
        localStorage.setItem('program', JSON.stringify('inpulse'))
        localStorage.setItem('edict_id', JSON.stringify(edict.value?.id))
    }

    classifiedProjects.value = edict.value.projetos?.filter(obj => obj.status == "Classificada");

    if (moment(edict.value.encerramento) < moment()) {
        subscriptionClosed.value = true
    }

    if (!authStore.value.user) {
        const returnUrl = subscriptionClosed.value
            ? { name: 'adicionar-programa' }
            : { name: 'adicionar-programa-inpulse' }
        localStorage.setItem('returnUrl', JSON.stringify(returnUrl))
    }
})

function saveReturnUrl(route) {
    localStorage.setItem('returnUrl', JSON.stringify(route))
}
</script>

<template>
    <div class="container mx-auto px-6 pt-12 pb-12">
        <div class="hidden md:flex justify-between flex-col md:flex-row items-center mb-8">
            <div>
                <CompBreadCrumbs>
                    <template v-slot:default>
                        <li>
                            <router-link :to="{ name: 'programas' }">
                                <IconsComp icon="editais-line" class="w-6 h-6" />
                                Programas
                            </router-link>
                        </li>
                        <li>
                            <router-link :to="{ name: 'programas-inpulse' }">
                                In.pulse
                            </router-link>
                        </li>
                    </template>
                </CompBreadCrumbs>
            </div>
        </div>

        <div v-if="!program || program?.loading" class="grid grid-cols-1 md:grid-cols-2 gap-4 items-center mt-10">
            <div class="font-bold font-poppins text-purple-800 text-center text-5xl md:py-10 mx-auto">
                <img src="@/assets/img/site/programa-inpulse-open.png" alt="Programa aberto" class="w-auto h-auto" />
            </div>
            <div>
                <div class="font-poppins font-bold text-purple-800 text-3xl md:text-6xl mb-4">
                    Programa In.pulse
                </div>
                <p>
                    No In.pulse, você tem a oportunidade de contar com a equipe do InovaHC para co-desenvolver seu
                    produto/serviço, aprimorar o seu modelo de negócios e ainda testar sua solução através de POCs e/ou
                    piloto.
                </p>
            </div>
        </div>
        <div v-else-if="!subscriptionClosed" class="grid grid-cols-1 md:grid-cols-2 gap-4 items-center mt-10">
            <div class="font-bold font-poppins text-purple-800 text-center text-5xl md:py-10 mx-auto">
                <img src="@/assets/img/site/programa-inpulse-open.png" alt="Programa aberto" class="w-auto h-auto" />
            </div>
            <div>
                <div class="font-poppins font-bold text-purple-800 text-3xl md:text-6xl mb-4">
                    Programa In.pulse
                </div>
                <p>
                    No In.pulse, você tem a oportunidade de contar com a equipe do InovaHC para co-desenvolver seu
                    produto/serviço, aprimorar o seu modelo de negócios e ainda testar sua solução através de POCs e/ou
                    piloto.
                </p>
                <div class="flex max-sm:flex-col max-sm:items-center max-sm:gap-4">
                    <router-link v-if="edict"
                        :to="authStore.user ? { name: 'adicionar-programa-inpulse', params: { editalId: edict.id } } : { name: 'primeiro-acesso-proponente' }"
                        @click="!authStore.user && saveReturnUrl({ name: 'adicionar-programa-inpulse' })"
                        class="btn primary mr-2 no-underline">Inscreva-se</router-link>
                    <a v-if="edict?.arquivo_edital" :href="edict?.arquivo_edital" type="button"
                        class="btn secondary no-underline" target="_blank">Leia o edital</a>
                    <button v-else type="button" class="btn secondary">Leia o edital</button>
                </div>
            </div>
        </div>
        <div v-else-if="subscriptionClosed" class="grid grid-cols-1 md:grid-cols-2 gap-4 items-center mt-10">
            <div class="font-bold font-poppins text-purple-800 text-center text-5xl py-10 mx-auto">
                <img src="@/assets/img/site/programa-close.png" alt="Programa Fechado" class="w-auto h-auto" />

            </div>
            <div>
                <div class="font-poppins font-bold text-purple-800 text-3xl md:text-6xl mb-4">
                    Prazo do edital {{ edict?.nome }} encerrado
                </div>
                <p class="font-bold">
                    Você ainda pode enviar sua proposta para nosso banco de projetos.
                </p>
                <p class="py-4">
                    Neste caso avaliaremos as propostas caso a caso de acordo com as características do projeto e nossos
                    recursos disponíveis.
                </p>

                <div class="flex">
                    <router-link
                        :to="authStore.user ? { name: 'adicionar-programa' } : { name: 'primeiro-acesso-proponente' }"
                        @click="!authStore.user && saveReturnUrl({ name: 'adicionar-programa' })"
                        class="btn primary mr-2 no-underline">Submeter
                        projeto</router-link>
                    <a v-if="classifiedProjects?.length > 0" href="#classifieds" role="button"
                        class="btn secondary ml-2 no-underline">Ver classificados
                        {{ edict?.nome }}</a>
                </div>
            </div>
        </div>

        <div class="text-2xl font-poppins font-bold text-purple-800 text-center mt-20">
            O que o programa In.pulse oferece
        </div>

        <div class="max-w-screen-lg mx-auto px-4 md:px-8 py-12 transition-all duration-500 ease-linear">

            <div class="relative">
                <div
                    class="slides-container h-72 flex md:overflow-hidden overflow-x-scroll space-2 rounded scroll-smooth max-sm:before-w-[0vw] max-sm:after:w-[0vw] before:w-[45vw] md:before:shrink-0 after:w-[45vw] after:shrink-0 md:before:w-0 md:after:w-0">
                    <div class="slide aspect-square m-2 flex-shrink-0 snap-center rounded-2xl 
                        overflow-hidden shadow-md w-56">
                        <div class="text-center p-2">
                            <IconsComp icon="add-circle" class="fill-purple-500 w-10 h-10  mx-auto " />
                            <div class="text-lg font-bold text-purple-800 my-4">
                                Co-desenvolvimento de protótipo de alta fidelidade
                            </div>
                            <p class="text-sm">
                                Te ajudamos a evoluir do protótipo de média fidelidade ao modelo mais próximo do seu produto
                                final.
                            </p>
                        </div>
                    </div>
                    <div
                        class="slide aspect-square m-2 flex-shrink-0 snap-center rounded-2xl overflow-hidden shadow-md w-56">
                        <div class="text-center p-2">
                            <IconsComp icon="add-circle" class="fill-purple-500 w-10 h-10 mx-auto" />
                            <div class="text-lg font-bold text-purple-800 my-4">
                                Piloto
                            </div>
                            <p class="text-sm">
                                Oferecemos a oportunidade de validar seu produto, serviço e/ou processo em ambiente
                                controlado e relevante para sua população.
                            </p>
                        </div>
                    </div>
                    <div
                        class="slide aspect-square m-2 flex-shrink-0 snap-center rounded-2xl overflow-hidden shadow-md w-56">
                        <div class="text-center p-2">
                            <IconsComp icon="add-circle" class="fill-purple-500 w-10 h-10  mx-auto " />
                            <div class="text-lg font-bold text-purple-800 my-4">
                                Product Market Fit
                            </div>
                            <p class="text-sm">
                                Vamos te ajudar a mirar e acertar no mercado correto para o seu negócio.
                            </p>
                        </div>
                    </div>
                    <div
                        class="slide aspect-square m-2 flex-shrink-0 snap-center rounded-2xl overflow-hidden shadow-md w-56">
                        <div class="text-center p-2">
                            <IconsComp icon="add-circle" class="fill-purple-500 w-10 h-10  mx-auto " />
                            <div class="text-lg font-bold text-purple-800 my-4">
                                POC (Proof of Concept)
                            </div>
                            <p class="text-sm">
                                Desenhamos juntos provas de conceito para validar seu produto, serviço e/ou processo.
                            </p>
                        </div>
                    </div>
                    <div
                        class="slide aspect-square m-2 flex-shrink-0 snap-center rounded-2xl overflow-hidden shadow-md w-56">
                        <div class="text-center p-2">
                            <IconsComp icon="add-circle" class="fill-purple-500 w-10 h-10  mx-auto " />
                            <div class="text-lg font-bold text-purple-800 my-4">
                                Modelagem de negócios
                            </div>
                            <p class="text-sm">
                                Mentorias exclusivas para desenvolver e aprimorar aspectos importantes do seu negócio.
                            </p>
                        </div>
                    </div>
                    <div
                        class="slide aspect-square m-2 flex-shrink-0 snap-center rounded-2xl overflow-hidden shadow-md w-56">
                        <div class="text-center p-2">
                            <IconsComp icon="add-circle" class="fill-purple-500 w-10 h-10  mx-auto " />
                            <div class="text-lg font-bold text-purple-800 my-4">
                                Espaço físico
                            </div>
                            <p class="text-sm">
                                Você pode contar com os benefícios do nosso espaço físico enquanto estiver no programa.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="absolute top-0 -left-16 h-full items-center flex max-sm:-left-8">
                    <button @click.prevent="clickCount > 0 ? clickCount-- : ''" role="button" class="prev p-1 rounded group"
                        :class="clickCount >= 1 ? 'bg-green-500 text-white' : 'bg-neutral-100 text-neutral-900'"
                        aria-label="prev"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                            stroke-width="1.5" stroke="currentColor"
                            class="w-5 h-5 group-active:-translate-x-2 transition-all duration-200 ease-linear">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
                        </svg>

                    </button>
                </div>
                <div class="absolute top-0 -right-16 h-full items-center flex max-sm:-right-8">
                    <button @click.prevent="clickCount < 2 ? clickCount++ : ''" role="button" class="next p-1 rounded group"
                        :class="clickCount <= 1 ? 'bg-green-500 text-white' : 'bg-neutral-100 text-neutral-900'"
                        aria-label="next"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                            stroke-width="1.5" stroke="currentColor"
                            class="w-5 h-5 group-active:translate-x-2 transition-all duration-200 ease-linear">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>

        <div v-if="!subscriptionClosed" class="text-center mt-4">
            <router-link v-if="edict"
                :to="authStore.user ? { name: 'adicionar-programa-inpulse', params: { editalId: edict.id } } : { name: 'primeiro-acesso-proponente' }"
                @click="!authStore.user && saveReturnUrl({ name: 'adicionar-programa-inpulse' })"
                class="btn primary no-underline">Inscreva-se</router-link>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 items-center mt-32">
            <div>
                <div class="font-poppins font-bold text-purple-800 text-2xl mb-4">
                    Para quem é o In.pulse
                </div>
                <p>
                    O programa In.pulse é para o empreendedor que já conhece seu usuário e possui um protótipo de média
                    fidelidade, ou seja, que conta com interfaces e simulações de interações já testadas. Não é necessário
                    ter um CNPJ.
                </p>
                <div v-if="!subscriptionClosed && program && !program?.loading"
                    class="flex max-sm:flex-col max-sm:gap-4 max-sm:items-center">
                    <router-link v-if="edict"
                        :to="authStore.user ? { name: 'adicionar-programa-inpulse', params: { editalId: edict.id } } : { name: 'primeiro-acesso-proponente' }"
                        @click="!authStore.user && saveReturnUrl({ name: 'adicionar-programa-inpulse' })"
                        class="btn primary mr-2 no-underline">Inscreva-se</router-link>
                    <a v-if="edict?.arquivo_edital" :href="edict?.arquivo_edital" type="button"
                        class="btn secondary no-underline" target="_blank">Leia o edital</a>
                    <button v-else type="button" class="btn secondary">Leia o edital</button>
                </div>
            </div>
            <div class="font-bold font-poppins text-purple-800 text-center text-5xl py-10 mx-auto">
                <img src="@/assets/img/site/programa-inpulse2.png" alt="InPulse" class="w-auto h-auto" />
            </div>
        </div>

    </div>
    <div v-if="subscriptionClosed && authStore.user && classifiedProjects?.length > 0" id="classifieds" class="bg-gray-50">
        <div class="container mx-auto px-6 py-24">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-10">
                <div>
                    <div class="font-bold font-poppins text-3xl text-purple-800 mb-4">
                        Classificados para edital {{ edict?.nome }}
                    </div>
                    <p class="font-poppins text-lg text-purple-500">Não foi classificado?</p>
                    <p>
                        Confira em seu email as orientações para requisitar interposição, mas corra que o prazo é curto.
                    </p>
                </div>
                <div>
                    <div v-for="classifiedProject in classifiedProjects" :key="classifiedProject"
                        class="pb-2 border-b border-gray-200 mb-4">
                        <div class="text-sm text-gray-400">Projeto</div>
                        <div class="font-bold text-green-600 mb-4">
                            {{ classifiedProject.nome_proposta }}
                        </div>
                        <div class="text-sm text-gray-400">Responsável</div>
                        <p>{{ classifiedProject.proponente.primeiro_nome }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="bg-gray-100">
        <div class="container mx-auto px-6 pt-4 mb-8">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 items-center ">
                <div class="font-bold font-poppins text-purple-800 text-center text-5xl py-6 md:py-10 mx-auto">
                    <img src="@/assets/img/site/programa-duvida.png" alt="Duvidas?" class="w-auto h-auto" />
                </div>
                <div>
                    <div class="font-poppins font-bold text-purple-800 text-2xl mb-4">
                        Alguma dúvida?
                    </div>
                    <p>
                        Se você tiver alguma dúvida sobre se encaixar nesse perfil, entre em contato conosco pelo e-mail:
                        <b>inovahc@hc.fm.usp.br</b>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<style type="text/css">
html {
    scroll-behavior: smooth;
}

.slides-container {
    -ms-overflow-style: none;
    /* Internet Explorer 10+ */
    scrollbar-width: none;
    /* Firefox */
}

.slides-container::-webkit-scrollbar {
    display: none;
    /* Safari and Chrome */
}
</style>